import { ArrowIdle } from "./ArrowIdle"
import { ArrowPointing } from "./ArrowPointing"

import { StateNode, TLStateNodeConstructor } from "tldraw"

export class LDArrowTool extends StateNode {
  static override id = "arrow2"
  static override initial = "arrow2-idle"
  static override children(): TLStateNodeConstructor[] {
    return [ArrowIdle, ArrowPointing]
  }

  override shapeType = "arrow2"
}
